import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/feature/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, articles, faqs } from '@/mocks/data';

export default function Home() {
  const featuredArticles = articles.slice(0, 6);
  const latestArticles = articles.slice(6);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '穿搭换装指南',
    url: 'https://yourdomain.com/',
    description: '美女脱衣服技巧全解析·穿搭换装指南，涵盖日常换装、穿搭搭配、脱衣顺序与收纳整理全流程。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '穿搭换装指南',
    url: 'https://yourdomain.com/',
    description: '专注女性穿搭换装技巧分享的优质内容平台。',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20in%20a%20flowing%20dress%20gracefully%20changing%20outfit%20in%20a%20bright%20airy%20bedroom%20with%20soft%20natural%20window%20light%2C%20minimalist%20cream%20and%20beige%20interior%2C%20fashion%20lifestyle%20editorial%20photography%2C%20warm%20atmosphere%2C%20feminine%20aesthetic%2C%20high%20quality&width=1800&height=900&seq=hero-main&orientation=landscape"
              alt="美女优雅换装"
              className="absolute inset-0 w-full h-full object-cover object-top"
              title="美女脱衣服技巧全解析·穿搭换装指南"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
            <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
              <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50 text-center max-w-3xl leading-tight">
                美女脱衣服技巧全解析 · 穿搭换装指南
              </h1>
              <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-100/90 text-center max-w-2xl leading-relaxed">
                涵盖日常换装、穿搭搭配、脱衣顺序与收纳整理全流程，帮助爱美女性快速掌握高效换装方法，让每次脱衣服都优雅得体、省时省力。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-4">
                <Link
                  to={`/category/${categories[0].slug}`}
                  className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap text-center"
                >
                  开始学习换装技巧
                </Link>
                <Link
                  to="/about"
                  className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap text-center"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8 md:mb-10">
                <h2 className="font-heading text-xl md:text-3xl text-foreground-900">
                  探索穿搭换装指南
                </h2>
                <p className="mt-2 text-sm md:text-base text-foreground-500">
                  四大核心板块，全方位提升你的换装体验
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="relative w-full h-40 overflow-hidden">
                      <img
                        src={cat.image}
                        alt={cat.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        title={cat.name}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                      <div className="absolute bottom-3 left-4 right-4">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90">
                            <i className={`${cat.icon} text-sm text-background-50`}></i>
                          </div>
                          <h3 className="font-heading text-base text-background-50">
                            {cat.name}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="p-4">
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                        {cat.description}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Featured Articles */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h2 className="font-heading text-xl md:text-3xl text-foreground-900">
                    精选文章
                  </h2>
                  <p className="mt-1 text-sm text-foreground-500">
                    最受欢迎的换装穿搭干货
                  </p>
                </div>
                <Link
                  to={`/category/${categories[0].slug}`}
                  className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {featuredArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
            <div className="max-w-7xl mx-auto">
              <div className="mb-8">
                <h2 className="font-heading text-xl md:text-3xl text-foreground-900">
                  最新发布
                </h2>
                <p className="mt-1 text-sm text-foreground-500">
                  持续更新更多换装穿搭内容
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} {...article} />
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-xl md:text-3xl text-foreground-900 text-center mb-8">
                常见问题解答
              </h2>
              <div className="space-y-3">
                {faqs.map((faq, index) => (
                  <details
                    key={index}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
                  >
                    <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                      <h4 className="font-heading text-sm md:text-base text-foreground-800 pr-4">
                        {faq.question}
                      </h4>
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full bg-secondary-100 group-open:bg-primary-100 transition-colors">
                        <i className="ri-add-line text-sm text-foreground-600 group-open:hidden"></i>
                        <i className="ri-subtract-line text-sm text-primary-600 hidden group-open:block"></i>
                      </div>
                    </summary>
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-foreground-500 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
            <div className="relative max-w-4xl mx-auto rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20women%20clothing%20and%20accessories%20beautifully%20arranged%20in%20a%20bright%20airy%20room%20with%20warm%20sunlight%2C%20fashion%20lifestyle%20photography%2C%20cream%20and%20beige%20tones%2C%20feminine%20aesthetic%2C%20editorial%20quality&width=1600&height=600&seq=cta-bg&orientation=landscape"
                alt="开始你的优雅换装之旅"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/20"></div>
              <div className="relative z-10 py-12 md:py-16 px-6 md:px-10 text-center">
                <h2 className="font-heading text-xl md:text-3xl text-background-50">
                  开启你的优雅换装之旅
                </h2>
                <p className="mt-3 text-sm md:text-base text-background-100/90 max-w-lg mx-auto">
                  从今天开始，学会科学换装、自信穿搭，让每一天都从容美丽。
                </p>
                <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
                  <Link
                    to={`/category/${categories[0].slug}`}
                    className="px-8 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
                  >
                    立即探索
                  </Link>
                  <Link
                    to="/about"
                    className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}